module.exports = __webpack_public_path__ + "img/GAME_YUTNORI.14102eee.png";